import { useNavigate, useParams } from 'react-router-dom';
import { EXTENDED_INTERVAL_UPDATE_DATA } from '../../../../../constants/common';
import { useAppDispatch, useAppSelector } from '../../../../../store/store';
import { useMemo, useRef, useState } from 'react';
import { usePolling } from '../../../../../hooks/usePolling';
import { Cycle } from '../../../../../store/models/cycles';
import { filterCyclesBySearchQuery } from '../../../../ContractScreensView/utils/filterCyclesBySearchQuery';

export interface IInactiveCycles {
  cycles: Cycle[];

  isLoading: boolean;
}

export const useInactiveCycles = (): IInactiveCycles => {
  const { clientId } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const {
    cycles: {
      getInactiveCyclesByLocation,
    }
  } = useAppDispatch();
  const { inactiveCycles, searchCycleQuery } = useAppSelector((state) => state.cycles);

  const cycles = useMemo(() => {
    if (!searchCycleQuery) {
      return inactiveCycles;
    }

    return filterCyclesBySearchQuery(inactiveCycles, searchCycleQuery);
  }, [inactiveCycles, searchCycleQuery]);

  const isChangeLoading = useRef(true);

  const fetchDataHandler = async (locationId: string) => {
    try {
      if (!locationId) {
        return;
      }

      if (isChangeLoading.current) {
        setIsLoading(true);
      }

      await getInactiveCyclesByLocation({ locationId });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isChangeLoading.current = false;
    }
  };

  usePolling(() => fetchDataHandler(clientId), EXTENDED_INTERVAL_UPDATE_DATA, [clientId, navigate]);

  return { cycles, isLoading };
}